import * as React from "react";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";
const CalendarTodayIcon = (props) => (
    <Svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <G clip-path="url(#clip0_7637_1370)">
            <Path d="M18.334 2.74935H17.4173V0.916016H15.584V2.74935H6.41732V0.916016H4.58398V2.74935H3.66732C2.65898 2.74935 1.83398 3.57435 1.83398 4.58268V19.2494C1.83398 20.2577 2.65898 21.0827 3.66732 21.0827H18.334C19.3423 21.0827 20.1673 20.2577 20.1673 19.2494V4.58268C20.1673 3.57435 19.3423 2.74935 18.334 2.74935ZM18.334 19.2494H3.66732V7.33268H18.334V19.2494Z" fill="#323232" />
        </G>
        <Defs>
            <ClipPath id="clip0_7637_1370">
                <Rect width="22" height="22" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>

);
export default CalendarTodayIcon;
